import { Plus } from "lucide-react";

export default function FAQ({ items, title = "Frequently Asked Questions" }) {
  return (
    <section className="container-x py-14 sm:py-20" data-testid="faq-section">
      <div className="max-w-3xl">
        <p className="eyebrow">Answers</p>
        <h2 className="section-title mt-3">{title}</h2>
        <span className="gold-rule mt-5" aria-hidden="true" />
      </div>
      <div className="mt-8 max-w-3xl divide-y divide-platinum border-y border-platinum">
        {items.map((item) => (
          <details key={item.q} className="group" data-testid={`faq-${item.q.toLowerCase().replace(/[^a-z]+/g, "-").replace(/-$/, "").slice(0, 40)}`}>
            <summary className="flex min-h-[56px] cursor-pointer list-none items-center justify-between gap-4 py-4 font-sub text-sm font-semibold text-navy transition-colors hover:text-gold-deep sm:text-base [&::-webkit-details-marker]:hidden">
              {item.q}
              <Plus size={18} aria-hidden="true" className="shrink-0 text-gold-deep transition-transform duration-200 group-open:rotate-45" />
            </summary>
            <p className="pb-5 pr-8 text-sm leading-relaxed text-slate">{item.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
